export default "__VITE_ASSET__DzYywo$3__"